import { t } from 'i18next';

export const validateEffectiveDate = (effectiveDate: string): string | null => {
  if (!effectiveDate) {
    return null;
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const selectedDate = new Date(effectiveDate);
  selectedDate.setHours(0, 0, 0, 0);

  if (selectedDate < today) {
    return t(
      'changeRequests.requestForm.salaryChange.effectiveDateMustBeInTheFuture',
    );
  }

  return null;
};

export const validateEndDate = (
  endDate: string,
  effectiveDate: string,
): string | null => {
  if (!endDate || !effectiveDate) {
    return null;
  }

  const effective = new Date(effectiveDate);
  effective.setHours(0, 0, 0, 0);

  const end = new Date(endDate);
  end.setHours(0, 0, 0, 0);

  if (end < effective) {
    return t(
      'changeRequests.requestForm.salaryChange.endDateMustBeAfterEffectiveDate',
    );
  }

  return null;
};

export const validateDateRange = (
  effectiveDate: string,
  endDate?: string,
): {
  effectiveDateError: string | null;
  endDateError: string | null;
} => {
  return {
    effectiveDateError: validateEffectiveDate(effectiveDate),
    endDateError: endDate ? validateEndDate(endDate, effectiveDate) : null,
  };
};
